import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, NonNullableFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Exception, PaymentHistoryResponse } from '@cargos/sprintpay-models';
import dayjs from 'dayjs';
import { finalize, take } from 'rxjs';
import { PaymentsFacilityService } from 'src/app/shared/services/payments.service';
import Swal from 'sweetalert2';
import { DateRangeFormType } from '../models/date-range';
import { FileFormatFormErrorJSON, FileFormatFormGroupType } from '../models/file-format-form';

@Component({
    selector: 'app-download-modal',
    templateUrl: './download-modal.component.html',
    styleUrls: ['./download-modal.component.scss'],
    standalone: false,
})
export class DownloadModalComponent implements OnInit {
    public isDownloading = false;
    public fileFormatForm: FileFormatFormGroupType;
    public fileFormats = ['XLSX', 'CSV', 'PDF'];
    public formError: FileFormatFormErrorJSON;
    public rangeDates: DateRangeFormType;
    public maxDate = 90;

    get fileFormatInput(): AbstractControl<string> | null {
        return this.fileFormatForm.get('fileFormat');
    }

    constructor(
        private fb: NonNullableFormBuilder,
        private matDialog: MatDialogRef<DownloadModalComponent>,
        private paymentsFacilityService: PaymentsFacilityService,
        @Inject(MAT_DIALOG_DATA) public data: { paymentsIDs: PaymentHistoryResponse[] }
    ) {}

    ngOnInit(): void {
        this.createForm();
    }

    createForm(): void {
        this.fileFormatForm = this.fb.group({
            fileFormat: ['', Validators.required],
        });
    }

    closeDialog(): void {
        this.matDialog.close();
    }

    downloadFiles(): void {
        this.isDownloading = true;

        let startDate = '';
        let endDate = '';
        let ids: string[] = [];
        let fileFormat = this.fileFormatInput?.value;

        if (this.data.paymentsIDs.length) {
            if (this.fileFormatForm.invalid) {
                return;
            }

            ids = this.data.paymentsIDs.map((payment) => payment.id.toString());
        } else {
            if (this.rangeDates.start && !this.rangeDates.end) {
                this.rangeDates.end = dayjs().format();
            } else if (!this.rangeDates.start && this.rangeDates.end) {
                this.rangeDates.start = dayjs().subtract(this.maxDate, 'days').format();
            }

            startDate = this.rangeDates.start && dayjs(this.rangeDates.start).format('YYYY-MM-DD');
            endDate = this.rangeDates.end && dayjs(this.rangeDates.end).format('YYYY-MM-DD');
            fileFormat = 'XLSX';
        }

        this.paymentsFacilityService
            .getPaymentConfirmations(ids, fileFormat, startDate, endDate)
            .pipe(
                take(1),
                finalize(() => {
                    this.isDownloading = false;
                })
            )
            .subscribe({
                error: (error: Exception) => {
                    Swal.fire({
                        title: error.title,
                        text: error.description,
                        icon: error.type,
                    });
                },
            });
    }

    eventOnChangeRange(dates: DateRangeFormType): void {
        this.rangeDates = dates;
    }
}
